import { render, staticRenderFns } from "./mmessage.vue?vue&type=template&id=3c02e860"
import script from "./mmessage.vue?vue&type=script&lang=js"
export * from "./mmessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports